import * as Yup from 'yup';

import { ZIP_INVALID } from 'lib/constants/messages';
import { US_ZIP_PATTERN } from 'lib/constants/demographics';

const formValidationSchema = Yup.object().shape({
  dbaName: Yup.string(),
  addressLabel: Yup.string().max(255, 'Max 255 characters'),
  address: Yup.object().shape({
    address_ln_1: Yup.string(),
    address_ln_2: Yup.string(),
    city: Yup.string(),
    state: Yup.string(),
    zip: Yup.string().matches(US_ZIP_PATTERN, { message: ZIP_INVALID, excludeEmptyString: true })
  }),
  locations: Yup.array().of(
    Yup.object().shape({
      label: Yup.string().trim().required('Label is required').max(255, 'Max 255 characters'),
      address: Yup.object().shape({
        address_ln_1: Yup.string(),
        address_ln_2: Yup.string(),
        city: Yup.string(),
        state: Yup.string(),
        zip: Yup.string()
      })
    })
  ),
  stickyNotesAlert: Yup.boolean(),
  requireInvoiceReview: Yup.boolean(),
  allowTips: Yup.boolean(),
  surchargeEnabled: Yup.boolean(),
  surchargeAmount: Yup.number().min(0).max(600),
  batchTime: Yup.string()
});

export default formValidationSchema;
